import { render, staticRenderFns } from "./modalBranch.vue?vue&type=template&id=412a327c"
import script from "./modalBranch.vue?vue&type=script&lang=js"
export * from "./modalBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports